<template>
    <el-form :model="merchtBizTypeInfo" :rules="merchtBizTypeRules" :label-position="'left'" ref="merchtBizType">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">财务业务类型</label>
                </div>
                <div class="form-value ">
                    <el-form-item prop="name">
                        <el-input class="width-1-5x" disabled type="text" v-model="merchtBizTypeInfo.refTypeName"></el-input>
                        <span class="form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon" v-if="typeId == null" title="选择" @click="selectFinacBizType()"></span>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>编码</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="innerCode">
                        <el-input v-model="merchtBizTypeInfo.innerCode"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="memo">
                        <el-input type="textarea" :rows="6" v-model="merchtBizTypeInfo.memo"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { selectFinacBizTypeDlg } from './dialog'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-mercht-biz-type-save',
        notAsResc: true,
        authen: false,
        desc: '商户业务管理-新增',
        props: {
            typeId: {
                type: Number
            }
        },
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            };
            return {
                merchtBizTypeInfo: {
                    forRetailer: true,
                    forVendor: true,
                    forServicer: true
                },
                merchtBizTypeRules: {
                    refTypeId: [{validator: checkNull, trigger: 'blur'}],
                }
            };
        },
        created: function () {
            if(!Utils.isNoB(this.typeId)) {
                this.getMerchtBizTypeInfo(this.typeId);
            }
        },
        methods: {
            getMerchtBizTypeInfo: function (typeId) {
                let self = this;
                let theLoader = MsgBox.loading();
                merchtComnApi.getMerchtBizTypeInfo({id: typeId}, function (result) {
                    theLoader.hide();
                    if(result.type == 'info') {
                        //
                        self.merchtBizTypeInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectFinacBizType: function () {
                let self = this;
                selectFinacBizTypeDlg({}, function (resultData) {
                    let merchtBizTypeInfo = self.merchtBizTypeInfo || {};
                    //
                    merchtBizTypeInfo.refTypeId = resultData.id;
                    merchtBizTypeInfo.refTypeName = resultData.name;
                    self.merchtBizTypeInfo = Utils.merge({}, merchtBizTypeInfo);
                });
            },
            getDlgResult() {
                let result = {
                    type: 'info'
                };
                let self = this;
                this.$refs['merchtBizType'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.merchtBizTypeInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/comn/MerchtBizTypeSave.vue